/**
 * card-cta
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module template
import './_card-cta.twig';
import './_card-cta.css';

export const name = 'card-cta';

export const defaults = {
  dummyClass: 'js-card-cta-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { cardCta = {} }) {
  // Find our component within the DOM
  const $cardCta = $('.card-cta', $context);
  // Bail if component does not exist
  if (!$cardCta.length) {
    return;
  }
  // Merge defaults with incoming settings
  const settings = {
    ...defaults,
    ...cardCta,
  };
  // An example of what could be done with this component
  $cardCta.addClass(settings.dummyClass);
}

export default enable;
